import React, { Component } from 'react'
import Card from 'Utils/Cards/cardGrande';
import HeaderIngresoBodega from 'Utils/Header/HeaderIngreso';
import DespachoForm from './DespachoForm';
import { api } from 'api/api';

let proveedores = [];
let timeoutBodega = null;
export default class DespachoCrear extends Component {
    componentWillMount() {
        this.props.uuidInitial();
    }

    getBodega = (search) => {
        return new Promise((resolve) => {
            // Si no hay texto, cargamos sin debounce (inicio)
            if (!search) {
                api.get("bodega", { search })
                    .then((data) => {
                        if (data && data.results) {
                            proveedores = data.results
                                .filter(x => x.id !== this.props.match.params.id)
                                .map(x => ({ value: x.id, label: x.nombre }));
                            resolve(proveedores);
                        } else {
                            resolve([]);
                        }
                    })
                    .catch(() => resolve([]));
                return;
            }

            // Si el usuario está escribiendo, aplicamos debounce
            clearTimeout(timeoutBodega);
            timeoutBodega = setTimeout(() => {
                api.get("bodega", { search })
                    .then((data) => {
                        if (data && data.results) {
                            proveedores = data.results
                                .filter(x => x.id !== this.props.match.params.id)
                                .map(x => ({ value: x.id, label: x.nombre }));
                            resolve(proveedores);
                        } else {
                            resolve([]);
                        }
                    })
                    .catch(() => resolve([]));
            }, 500); // 500 ms de espera entre llamadas
        });
    }

    render() {
    const { nombreBodega, updateData, crearDespacho, regresar,initCantidad } = this.props;
    return (
        <div className="container m-0 contenido-principal row d-flex justify-content-center">
            <div className="col-md-12">
                <HeaderIngresoBodega
                    principal={updateData.principal ? updateData.principal : false}
                    titulo={updateData.nombre || this.props.me.nombre_bodega || ''}
                    subtitulo="Despacho"
                    bodegaId={updateData.id || this.props.me.bodega}
                />
                <div className="col-md-12">
                    <DespachoForm
                        bodega={updateData.id ? updateData : { id: this.props.me.bodega }}
                        getBodega={this.getBodega}
                        regresar={regresar}
                        onSubmit={crearDespacho}
                        initCantidad={initCantidad}/>
                </div>
            </div>
        </div>
    )
}
}
